// @flow

import React from 'react';
import CustomModal from '../../../../../elements/CustomModal/CustomModal';
import {Typography, makeStyles} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import {Add} from '@material-ui/icons';

import {useToggle} from '../../../../../utils/react';
import OpenConversationForm from '../../../chat/components/MultiChat/ConversationsGrid/OpenConversation/OpenConversationForm';

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: colors.grey900,
    textAlign: 'center',
  },
  defaultModal: {
    '& .MuiPaper-root': {
      padding: theme.spacing(2, 2, 0, 2),
    },
  },
  modal: {
    padding: theme.spacing(5, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 400,
  },
  button: {
    backgroundColor: 'transparent !important',
  },
  dashedButton: {
    width: '100%',
    border: `1px dashed ${colors.grey500}`,
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '10px',
    '& svg': {
      color: colors.grey800,
    },
    '& p': {
      fontSize: 14,
      color: colors.grey800,
    },
  },
}));

const AddNewCardModal = () => {
  const classes = useStyles();

  const [modalOpen, toggleModalOpen] = useToggle(false);

  return (
    <div className={classes.wrap}>
      <CustomButton
        className={classes.dashedButton}
        onClick={toggleModalOpen}
        fullWidth
      >
        <Add />
        <Typography>Nueva conversación</Typography>
      </CustomButton>
      <CustomModal open={modalOpen} onClose={toggleModalOpen}>
        <OpenConversationForm onSubmitSuccess={toggleModalOpen} />
      </CustomModal>
    </div>
  );
};

export default AddNewCardModal;
